import { render } from "./DipocacoApp.vue?vue&type=template&id=67eaa03a"
import script from "./DipocacoApp.vue?vue&type=script&lang=js"
export * from "./DipocacoApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__